import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { VeeVal } from "./VeeValidateHelper";
import VueScript2 from "vue-script2";
import VModal from "vue-js-modal";
import VueScrollTo from "vue-scrollto";
import VueMask from "v-mask";

Vue.use(VeeVal);
Vue.use(VueScript2);
Vue.use(VModal);
Vue.use(VueMask);

Vue.use(VueScrollTo, {
  container: "body",
  duration: 500,
  easing: "ease",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
